import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CalendarUtilsService {
  combineDateTime(dateStr: string, timeStr: string): Date {
    const [day, month, year] = dateStr.split('/');
    const formattedDateStr = `${month}/${day}/${year} ${timeStr}`;
    return new Date(formattedDateStr);
  }

  formatDate(dateString: string): string {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month}-${day}`;
  }

  calculateEndTime(startTime: string, lengthInMinutes: string): string {
    const timeParts = startTime.split(':');
    const duration = parseInt(lengthInMinutes);
    const date = new Date();
    date.setHours(parseInt(timeParts[0]), parseInt(timeParts[1]), 0, 0);
    date.setMinutes(date.getMinutes() + duration);

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }

  combineDateTimeAndLength(
    date: string,
    time: string,
    length: string
  ): { start: Date; end: Date } {
    const [day, month, year] = date.split('/');
    const fullDate = `${year}-${month}-${day}T${time}:00`; // Formatta la data e l'ora in formato ISO 8601
    const startTime = new Date(fullDate);
    const durationMinutes = parseInt(length);
    const endTime = new Date(startTime.getTime() + durationMinutes * 60000); // Aggiunge la durata in minuti alla data di inizio
    return { start: startTime, end: endTime };
  }

  // Funzione per convertire data e orario nei formati accettati
  convertDateTime(date: string, time: string): string {
    const [day, month, year] = date.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(
      2,
      '0'
    )}T${time}:00`;
  }

  addOneHour(date: Date): Date {
    let newDate = new Date(date.getTime()); // Clona l'oggetto Date per evitare mutazioni indesiderate
    newDate.setHours(date.getHours() + 1);
    return newDate;
  }

  // New method to format Date object to DD/MM/YYYY
  formatDateFromDateObject(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  formatTimeFromDateObject(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  convertStringDateAndTimeToDateObject(date: string, time: string): Date {
    const [day, month, year] = date.split('/').map(Number);
    const [hours, minutes] = time.split(':').map(Number);
    return new Date(year, month - 1, day, hours, minutes);
  }

  getTodayStringDate(): string {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
  }

  // Add other utility methods...
}
